import { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { Inject } from 'inversify-props'
import type { ImportacaoDeNotaServiceAdapter } from './adapter'

export class FinalizarImportacaoDeNotaDoFornecedorUseCase {
	@Inject('ImportacaoDeNotaServiceAdapter')
	private importacaoDeNotaServiceAdapter!: ImportacaoDeNotaServiceAdapter

	async execute(urlDoArquivoJson: string, naoDeveMovimentarEstoque: boolean, naoDeveAtualizarTabelaDePreco: boolean): Promise<ImportacaoDeNota> {
		return await this.importacaoDeNotaServiceAdapter.finalizarImportacao(urlDoArquivoJson, naoDeveMovimentarEstoque, naoDeveAtualizarTabelaDePreco)
	}

	async importarNotaFiscalParaPedido(arquivo: File | null, pedidoId: string){
		if (!arquivo) throw new Error('Arquivo não informado')
		return await this.importacaoDeNotaServiceAdapter.importarNotaFiscalParaPedido(arquivo, pedidoId)
	}
}